import React from 'react';
import { Box } from '@mui/material';
import { chatUnreadBadgeSx } from './chatUnreadBadgeStyles';

export interface ChatUnreadBadgeProps {
  count: number;
  size?: 'nav' | 'list';
  className?: string;
}

function formatUnreadCount(count: number): string {
  if (count > 99) {
    return '99+';
  }
  return String(count);
}

const ChatUnreadBadge: React.FC<ChatUnreadBadgeProps> = ({ count, size = 'nav', className }) => {
  if (count <= 0) {
    return null;
  }

  const label = formatUnreadCount(count);

  return (
    <Box
      component="span"
      className={className}
      role="status"
      aria-live="polite"
      aria-label={`${count} unread messages`}
      sx={chatUnreadBadgeSx(size)}
    >
      {label}
    </Box>
  );
};

export default ChatUnreadBadge;
